import { useMemo } from 'react';

import type { ApprovalChainFormContext, ApprovalChainFormInput } from '../../model/schema';
import type { StepRoleCatalogue } from '../ApproverPicker';

/** The steps as saved, and who holds each role, for the form's checks. */
export function useApprovalChainFormContext(
  initialValues: ApprovalChainFormInput | undefined,
  stepRoles: StepRoleCatalogue,
): ApprovalChainFormContext {
  const roleHolders = stepRoles.kind === 'ready' ? stepRoles.holders : null;
  const savedSteps = useMemo(() => {
    const byId = new Map<string, ApprovalChainFormInput['steps'][number]>();
    for (const step of initialValues?.steps ?? []) {
      if (step.stepId) byId.set(step.stepId, step);
    }
    return byId;
  }, [initialValues]);

  return useMemo(() => ({ savedSteps, roleHolders }), [savedSteps, roleHolders]);
}
